import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { groupBy } from "lodash";
import ReminderItem from "./reminder-item";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "RemindersPopover",
  components: {
    ReminderItem
  },
  props: {
    reminders: {
      type: Array,
      required: true
    }
  },
  computed: {
    remindersByClassification() {
      return groupBy(this.reminders, reminder => this.$options.filters.followupClassification(reminder.scheduledDate));
    },
    noReminders() {
      return this.reminders.length === 0;
    },
    classificationOrder() {
      const order = ["past-due", "active", "upcoming", "planned"];
      const currentClassifications = _Object$keys(this.remindersByClassification);
      return _filterInstanceProperty(order).call(order, key => _includesInstanceProperty(currentClassifications).call(currentClassifications, key));
    }
  },
  methods: {
    getClassificationTitle(classification) {
      const titleMapper = {
        "past-due": this.$tc("boards.remindersClassifications.past-due", 1),
        active: this.$t("boards.remindersClassifications.active"),
        upcoming: this.$tc("boards.remindersClassifications.upcoming", 1),
        planned: this.$tc("boards.remindersClassifications.planned", 1)
      };
      return titleMapper[classification];
    },
    handleReminderComplete(reminder) {
      this.$emit("reminder-complete", reminder);
    },
    handlePopoverClose() {
      this.$emit("close");
    },
    handleNewReminder() {
      this.$emit("reminder-create");
    },
    handleChange(reminder) {
      this.$emit("change", reminder);
    },
    getPopoverTarget() {
      return this.$refs.popoverTarget;
    }
  }
});